module.exports = __webpack_public_path__ + "img/adhka-yx1zn.016.21180fb7.png";